var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
let QboCard = class QboCard extends LitElement {
    constructor() {
        super(...arguments);
        this.display = 'normal';
        this.trigger = 'header';
        this.renderInHost = true;
        this.hasExpandedContent = false;
        this.minimize = (event) => {
            this.display = 'minimize';
        };
        this.normal = (event) => {
            this.display = 'normal';
        };
        this.maximize = (event) => {
            this.display = 'maximize';
        };
    }
    static { this.styles = [
        css ``
    ]; }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', this.handleClick);
        document.addEventListener('qbo-card-minimize', this.minimize);
        document.addEventListener('qbo-card-normal', this.normal);
        document.addEventListener('qbo-card-maximize', this.maximize);
        this.hasExpandedContent = (this.querySelector('.expanded') != null);
        if (this.display === 'normal' && !this.hasExpandedContent)
            this.display = 'maximize';
    }
    disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        document.removeEventListener('qbo-card-minimize', this.minimize);
        document.removeEventListener('qbo-card-normal', this.normal);
        document.removeEventListener('qbo-card-maximize', this.maximize);
        super.disconnectedCallback();
    }
    attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'display') {
            this.classList.remove('normal', 'minimize', 'maximize');
            if (newValue) {
                this.classList.add(newValue);
            }
        }
    }
    // Handle click events on the header to toggle state
    handleClick(event) {
        const source = event.composedPath()[0];
        const target = this.querySelector(this.trigger);
        if (source === target) {
            (event.ctrlKey) ? this.shrink() : this.grow();
        }
    }
    shrink() {
        switch (this.display) {
            case 'minimize':
                this.display = 'maximize';
                return;
            case 'maximize':
                this.display = this.hasExpandedContent ? 'normal' : 'minimize';
                return;
            default:
                this.display = 'minimize';
                return;
        }
    }
    grow() {
        switch (this.display) {
            case 'minimize':
                this.display = this.hasExpandedContent ? 'normal' : 'maximize';
                return;
            case 'maximize':
                this.display = 'minimize';
                return;
            default:
                this.display = 'maximize';
                return;
        }
    }
    createRenderRoot() {
        return this.renderInHost ? this : super.createRenderRoot();
    }
    render() {
        return html `<slot></slot>`;
    }
};
__decorate([
    property({ reflect: true }),
    __metadata("design:type", String)
], QboCard.prototype, "display", void 0);
__decorate([
    property(),
    __metadata("design:type", String)
], QboCard.prototype, "trigger", void 0);
__decorate([
    property(),
    __metadata("design:type", Boolean)
], QboCard.prototype, "renderInHost", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboCard.prototype, "columns", void 0);
QboCard = __decorate([
    customElement('qbo-card')
], QboCard);
export { QboCard };
